import React from 'react';
import { Monitor, Tablet, Smartphone } from 'lucide-react';

const VIEWPORTS = [
  { id: 'desktop', icon: Monitor, label: 'Desktop', width: '100%', height: '100%' },
  { id: 'tablet', icon: Tablet, label: 'Tablet', width: '768px', height: '1024px' },
  { id: 'mobile', icon: Smartphone, label: 'Mobile', width: '375px', height: '812px' },
];

export default function ViewportToggle({ viewport = 'desktop', onViewportChange }) {
  const current = VIEWPORTS.find(v => v.id === viewport) || VIEWPORTS[0];

  return (
    <div className="flex items-center gap-1.5">
      <div className="flex items-center bg-[var(--orbis-s1)] rounded-lg p-0.5 border border-[rgba(255,255,255,0.07)]">
        {VIEWPORTS.map(v => {
          const Icon = v.icon;
          const isActive = viewport === v.id;
          return (
            <button
              key={v.id}
              onClick={() => onViewportChange(v.id)}
              title={`${v.label} preview${v.id !== 'desktop' ? ` (${v.width} × ${v.height})` : ''}`}
              className={`p-1.5 rounded-md transition-all ${
                isActive
                  ? 'bg-[var(--orbis-s2)] text-[var(--orbis-t1)] shadow-sm'
                  : 'text-[var(--orbis-t4)] hover:text-[var(--orbis-t3)]'
              }`}
            >
              <Icon className="w-3.5 h-3.5" />
            </button>
          );
        })}
      </div>
      {viewport !== 'desktop' && (
        <span className="text-[10px] text-[var(--orbis-t4)] font-mono tabular-nums">
          {current.width} × {current.height}
        </span>
      )}
    </div>
  );
}

export { VIEWPORTS };
